const fetchDOMDocument = async url => {
  const xhr = new XMLHttpRequest();
  return new Promise((resolve, reject) => {
    xhr.onload = () => {
      if (xhr.status === 200 || xhr.statusText === 'OK') {
        try {
          const doc = xhr.responseXML;
          const body = doc && doc.documentElement ? doc.documentElement.querySelector('body') : null;
          resolve(body);
        } catch (e) {
          reject(e);
        }
      } else {
        reject(xhr.statusText);
      }
    };
    xhr.onerror = () => reject(xhr.statusText);
    xhr.open('GET', url);
    xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');
    xhr.responseType = 'document';
    xhr.send();
  });
};
export default fetchDOMDocument;